import { render } from "./landlord_dtl.vue?vue&type=template&id=4d824d83&scoped=true"
import script from "./landlord_dtl.vue?vue&type=script&lang=js"
export * from "./landlord_dtl.vue?vue&type=script&lang=js"

import "./landlord_dtl.vue?vue&type=style&index=0&id=4d824d83&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d824d83"]])

export default __exports__